import { Pipe, PipeTransform } from "@angular/core";

import { Model } from "../model/model";

@Pipe({
    name: 'filterModels'
})

export class FilterModelsPipe implements PipeTransform {

    transform(value: Array<Model>, showOnlyFavorites: boolean, numBedrooms: string, squareFootage: any) {
		let temp;
		// NOTE: the use of "!=" below is intentional and will catch both null and undefined
		if (showOnlyFavorites === true && value != null) {
            temp = value.filter(x => {
                return x.Favorite === true && numBedrooms.toString().includes(x.Bedrooms.toString()) && (x.SquareFeet >= squareFootage.min && x.SquareFeet < squareFootage.max)
            });
            if (temp.length === 0) { return [{ empty: true, message: 'No Matches Found.' }] }
            return temp;
        }
		if (showOnlyFavorites === false && value != null) {
            temp = value.filter(x => {
                return numBedrooms.toString().includes(x.Bedrooms.toString()) && (x.SquareFeet >= squareFootage.min && x.SquareFeet < squareFootage.max)
            });
            if (temp.length === 0) { return [{ empty: true, message: 'No Matches Found.' }] }
            return temp;
        }
        return value;
    }
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./src/app/pipes/models-filter.pipe.ts